import LABEL from '../../business-const/Label/Label'

import {
    existeTabelaEvolucaoValorResgate,
} from '../../views/clientes/seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'



const tabEstudoFormParametrosList = (values, linhaTipoLicenca) => {

    const tabEstudoFormParametrosList = []

    let cont = 0

    const letra = ''//'b.'

    cont++
    
    if (linhaTipoLicenca.exibirEstudoParametrosCompleto === 'S') {
        
        tabEstudoFormParametrosList.push(
            letra + (cont++) + ') ' + LABEL.cenariosTaxas,
            letra + (cont++) + ') ' + LABEL.idades,
            letra + (cont++) + ') ' + LABEL.exclusoes,
        )
    }

    if (linhaTipoLicenca.exibirEstudoParametrosCompleto === 'S' && linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S') {
    
        tabEstudoFormParametrosList.push(
            letra + (cont++) + ') ' + LABEL.configuracaoAcumulacao,
        )
    }

    if (linhaTipoLicenca.exibirEstudoParametrosCompleto === 'S') {
        
        tabEstudoFormParametrosList.push(
            letra + (cont++) + ') ' + LABEL.configuracaoProtecao,
        )

        if (existeTabelaEvolucaoValorResgate(values)) {

            tabEstudoFormParametrosList.push(
                letra + (cont++) + ') ' + LABEL.configuracaoGestaoPatrimonial,
            )
        }
    }

    tabEstudoFormParametrosList.push(
        letra + (cont++) + ') ' + LABEL.paginaAdicional,
    )

    tabEstudoFormParametrosList.push(
        letra + (cont++) + ') ' + LABEL.configuracaoRelatorio,
    )

    return tabEstudoFormParametrosList
}

export default tabEstudoFormParametrosList